import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';
import { TransHeaderSteperComponent } from '../../components/trans-header-steper/trans-header-steper.component';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-indus-x-transaction',
  standalone:false,
  templateUrl: './indus-x-transaction.component.html',
})
export class IndusXTransactionComponent{

}
